let hasSessionStorageTestRun = false
let isSessionStorageSupport = false

const runSessionStorageTest = () => {
  const test = 'doesSessionStorageExistTest'
  try {
    window.sessionStorage.setItem(test, 'Y')
    window.sessionStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}

export function isSessionStorageAvailable () {
  if (!hasSessionStorageTestRun) {
    hasSessionStorageTestRun = true
    isSessionStorageSupport = runSessionStorageTest()
  }
  return isSessionStorageSupport
}

export function setItemSessionStorage (key, value) {
  if (isSessionStorageAvailable()) window.sessionStorage.setItem(key, value)
}

export function getItemSessionStorage (key) {
  if (isSessionStorageAvailable()) return window.sessionStorage.getItem(key)
}

export function removeSessionStorage (key) {
  if (isSessionStorageAvailable()) return window.sessionStorage.removeItem(key)
}
